import { render, staticRenderFns } from "./EventHubEventSourceUpdateDialog.vue?vue&type=template&id=65772122&"
import script from "./EventHubEventSourceUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./EventHubEventSourceUpdateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports